declare namespace $ {

	type $mol_text__text_milis_log_demo_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__value_milis_log_demo_2 = $mol_type_enforce<
		ReturnType< $milis_log_demo['input_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_milis_log_demo_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_milis_log_demo_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_paragraph__title_milis_log_demo_5 = $mol_type_enforce<
		ReturnType< $milis_log_demo['input_length'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_labeler__title_milis_log_demo_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_milis_log_demo_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_textarea__value_milis_log_demo_8 = $mol_type_enforce<
		ReturnType< $milis_log_demo['v'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_labeler__title_milis_log_demo_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_milis_log_demo_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_text__text_milis_log_demo_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_milis_log_demo_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $milis_log_demo extends $mol_example_small {
		Info( ): $mol_text
		input_value( next?: string ): string
		Input( ): $mol_string
		Input_label( ): $mol_labeler
		input_length( ): string
		Input_length( ): $mol_paragraph
		Length_label( ): $mol_labeler
		v( next?: string ): string
		T( ): $mol_textarea
		Example_label( ): $mol_labeler
		Image( ): $mol_text
		Layout( ): $mol_list
		title( ): string
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map